import GoogleAnalyticsTracking from './GoogleAnalyticsTracking';

export default GoogleAnalyticsTracking;
